export enum PnMedicationConstants {
  SET_MEDICATION_PNNV = 'pnMedication/SET_MEDICATION_PNNV',
  SET_MEDICATION = 'pnMedication/SET_MEDICATION',
  SET_DOSE = 'pnMedication/SET_DOSE',
  SET_DOSE_UNIT = 'pnMedication/SET_DOSE_UNIT',
  SET_DOSE_UNIT_PNNV = 'pnMedication/SET_DOSE_UNIT_PNNV',
  SET_ROUTE = 'pnMedication/SET_ROUTE',
  SET_ROUTE_PNNV = 'pnMedication/SET_ROUTE_PNNV',
  SET_KEY = 'pnMedication/SET_KEY',
  SET_DATE_TIME = 'pnMedication/SET_DATE_TIME',
  SET_DATE = 'pnMedication/SET_DATE',
  SET_TIME = 'pnMedication/SET_TIME',
  SET_PTA = 'pnMedication/SET_PTA',
  SET_RESPONSE = 'pnMedication/SET_RESPONSE',
  ADD_PN_MEDICATION = 'pnMedication/ADD_PN_MEDICATION',
  SET_ADD_PN_MEDICATION_DATA = 'pnMedication/SET_ADD_PN_MEDICATION_DATA',
  DELETE_PN_MEDICATION = 'pnMedication/DELETE_PN_MEDICATION',
  SET_ADD_TO_TIMELINE = 'pnMedication/SET_ADD_TO_TIMELINE',
  SAVE_PN_MEDICATION = 'pnMedication/SAVE_PN_MEDICATION',
  SET_STATE = 'pnMedication/SET_STATE',
  RESET_STATE = 'pnMedication/RESET_STATE',
}
